var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { PureComponent } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { bool, expression, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { InlineImage } from '../inline-image/inline-image.js';
import { Loader } from '../loader/loader.js';
import ImageAPI from './image-api.js';
import './image.css';
let Image = class Image extends PureComponent {
    getClassName() {
        const { className } = this.props;
        return classNames({
            'c-image': true,
            [`${className}`]: Boolean(className),
        });
    }
    render() {
        const { alt, height, loading, maxHeight, maxWidth, minHeight, minWidth, preventContextMenu, src, visible, width } = this.props;
        if (!visible || !src) {
            return null;
        }
        const inlineImageProps = {
            className: this.getClassName(),
            imageAlt: MessageService.translate(alt),
            imageStyle: { height, maxHeight, maxWidth, minHeight, minWidth, width },
            preventContextMenu,
            src,
        };
        return (loading
            ? React.createElement(Loader, { size: 64 })
            : React.createElement(InlineImage, { ...inlineImageProps }));
    }
};
Image.propTypes = {
    alt: expression,
    className: string,
    height: string.group('size'),
    loading: bool,
    maxHeight: string.group('size'),
    maxWidth: string.group('size'),
    minHeight: string.group('size'),
    minWidth: string.group('size'),
    preventContextMenu: bool,
    src: string,
    uuid: string,
    visible: bool,
    width: string.group('size'),
};
Image.defaultProps = {
    height: 'auto',
    visible: true,
    width: '100%',
};
Image = __decorate([
    AwesomeComponent({ api: ImageAPI, type: ComponentType.DATA_DISPLAY })
], Image);
export { Image, };
//# sourceMappingURL=image.js.map